import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from 'src/app/app.service';
import {Constants} from 'src/app/shared/utils/constants';
import {CmsService} from '../cms.service';
import {Broadcaster} from '../../../app.broadcast';

@Component({
  selector: 'rox-suspended-users',
  templateUrl: './suspended-users.component.html',
  styleUrls: ['./suspended-users.component.sass'],
})
export class SuspendedUsersComponent  implements OnInit, OnDestroy {
  users: any = [];
  user: any;
  subscription: any = {};
  suspendedUsers: any = [];
  searchKey: string = '';
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 15,
    totalRecord: 0,
  };
  loading = false;
  constructor(
    private service: CmsService,
    public  broadcaster: Broadcaster,
    public appService: AppService ) {
      this.getSuspendedListUser()
  }

  ngOnInit(): void {}

  getSuspendedListUser(): void {
    const params = {
      q: this.searchKey ? (this.searchKey.trim()) : this.searchKey,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.subscription.suspendedUsers = this.service.getSuspendedListUser(params)
    .subscribe((data: any) => {
      if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.suspendedUsers = data.data
        this.pageInfo.totalRecord = data.paging.total;
        this.loading = false;
      }
    });
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getSuspendedListUser()
  }

  search(): void{
    this.pageInfo.pageIndex = 1;
    this.getSuspendedListUser()
  }

  refresh():void{
    this.searchKey = ''
    this.pageInfo.pageIndex = 1
    this.loading = true
    this.getSuspendedListUser()
  }

  unSuspend(login: any): void {
    this.appService
        .confirm({
          title: `Are you sure that you want to Unsuspend Account number ${login}?`,
          ok: 'Yes',
          cancel: 'No',
        })
        .subscribe((res: any) => {
          if (res.result) {
            this.subscription.unsuspend = this.service
            .unsuspendUser({ mt5_account: login})
            .subscribe((data: any) => {
              if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
                this.appService.showSuccess('Unsuspend successful');
                this.suspendedUsers = this.suspendedUsers.filter(sus=> sus.login !== login)
              } else {
                this.appService.showSuccess('Unsuspend fail');
              }
            });
          }
        });
  }

  ngOnDestroy(): void {
    for (const prop in this.subscription) {
      if (this.subscription[prop]) {
        this.subscription[prop].unsubscribe();
      }
    }

  }
}
